import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d76643d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "filter-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.filter.fieldType)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent($setup.getComponent($props.filter)), {
          filter: $props.filter,
          label: $props.filter.label,
          name: $props.filter.label,
          placeholder: $props.placeholder,
          required: !!$props.filter.essential,
          disabled: $props.disabled,
          value: $setup.inputValue,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event)),
          onOnSelectOption: $setup.emitOnSelectOption,
          onOnInput: $setup.emitOnUpdateValue
        }, null, 40 /* PROPS, NEED_HYDRATION */, ["filter", "label", "name", "placeholder", "required", "disabled", "value"]))
      ]))
    : _createCommentVNode("v-if", true)
}